import { NotificationFormValues, stopSendingOptions } from "./types";

export const getMaxSendDateTime = (
  baseDate: Date,
  values: NotificationFormValues
): string | null => {
  if (values.stopSendingOption === "anytime") {
    return null;
  }

  if (!values.sendDateTime) {
    return null;
  }

  let minutesToAdd = 0;

  if (values.stopSendingTimeUnit === "custom") {
    // Custom time setting
    if (values.stopSendingCustomUnit === "minutes") {
      minutesToAdd = values.stopSendingCustomValue;
    } else {
      // hours
      minutesToAdd = Math.round(values.stopSendingCustomValue * 60);
    }
  } else {
    // Predefined option
    const selectedOption = stopSendingOptions.find((option) => {
      if (values.stopSendingTimeValue === 5) return option.value === "5min";
      if (values.stopSendingTimeValue === 15) return option.value === "15min";
      if (values.stopSendingTimeValue === 30) return option.value === "30min";
      if (
        values.stopSendingTimeValue === 1 &&
        values.stopSendingTimeUnit === "hours"
      )
        return option.value === "1hour";
      if (
        values.stopSendingTimeValue === 3 &&
        values.stopSendingTimeUnit === "hours"
      )
        return option.value === "3hours";
      if (
        values.stopSendingTimeValue === 6 &&
        values.stopSendingTimeUnit === "hours"
      )
        return option.value === "6hours";
      if (
        values.stopSendingTimeValue === 12 &&
        values.stopSendingTimeUnit === "hours"
      )
        return option.value === "12hours";
      return false;
    });

    if (selectedOption) {
      if (selectedOption.minutes) {
        minutesToAdd = selectedOption.minutes;
      } else if (selectedOption.hours) {
        minutesToAdd = selectedOption.hours * 60;
      }
    }
  }

  const newDate = new Date(baseDate.getTime() + minutesToAdd * 60000);
  return newDate.toISOString().replace(/\.[0-9]{3}Z$/, ".0000000Z");
};
